var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.playerIsPlaying)?_c('a-icon',{staticClass:"play-button",attrs:{"type":"pause-circle"},on:{"click":_vm.pause}}):_c('a-icon',{staticClass:"play-button",attrs:{"type":"play-circle"},on:{"click":_vm.play}})}
var staticRenderFns = []

export { render, staticRenderFns }